import React from "react";
import { TagsContextInterface } from "types/tags";

export const TagsContext = React.createContext<TagsContextInterface>({
  navigationSets: [],
  setNavigationSets: (
    _navigationSets: TagsContextInterface["navigationSets"]
  ) => {},
});
